function Triangle(){

    return(
        <div className="background-anim">
        <div className="triangle-1">
            <div className="triangle-1-white">
            <div className="triangle-2">
                <div className="triangle-2-white">
                    <div className="triangle-3">
                        <div className="triangle-3-white"></div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
    )
}

export default Triangle;